import Button from "components/Button";
import { RiBankCard2Line, RiBankLine, RiPaypalLine } from "@remixicon/react";
import { getPaymentSourceTitle, PaymentSource } from "types/billing/PaymentSource";


interface PaymentMethodDisplayProps {
  paymentSource: PaymentSource | undefined;
  onChangeClick: () => void;
  showWireTransferBanner?: boolean;
}

export default function PaymentMethodDisplay({
  paymentSource,
  onChangeClick,
  showWireTransferBanner = false,
}: PaymentMethodDisplayProps) {

  // Wire transfer info banner (no longer gates card management)
  if (showWireTransferBanner) {
    return (
      <div className="flex items-center gap-4 p-4 border border-gray-200 rounded">
        <div className="w-12 h-12 bg-neutral-50 rounded flex items-center justify-center flex-shrink-0">
          <RiBankLine
            size={24}
            className="text-gray-600"
          />
        </div>
        <div className="flex flex-col gap-1">
          <p className="text-base font-medium text-gray-900">
            Your invoices are paid by bank transfer
          </p>
          <p className="text-sm text-gray-600">
            You can add or edit backup payment methods below. To change your bank transfer details, please{" "}
            <a
              href="mailto:support@scraperapi.com"
              className="underline hover:text-primary-700"
            >
              contact our support team
            </a>.
          </p>
        </div>
      </div>
    );
  }

  if (!paymentSource) {
    return (
      <div className="flex items-center justify-between p-4 border border-gray-200 rounded">
        <p className="text-sm text-gray-600">
          No payment method on file
        </p>
        <Button
          text="ADD"
          onClick={onChangeClick}
          className="button button-primary"
          size="SM"
        />
      </div>
    );
  }

  // PayPal payment method display
  if (paymentSource.type === "paypal") {
    return (
      <div className="flex items-center justify-between p-4 border border-gray-200 rounded">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 bg-neutral-50 rounded flex items-center justify-center">
            <RiPaypalLine
              size={24}
              className="text-neutral-500"
            />
          </div>
          <div className="flex flex-col">
            <p className="text-base font-medium text-gray-900">
              PayPal
            </p>
            {paymentSource.paypalEmail && (
              <p className="text-sm text-gray-600">
                {paymentSource.paypalEmail}
              </p>
            )}
          </div>
        </div>
        <Button
          text="CHANGE"
          onClick={onChangeClick}
          className="button button-secondary"
          size="SM"
        />
      </div>
    );
  }

  // Card payment method display
  return (
    <div className="flex items-center justify-between p-4 border border-gray-200 rounded">
      <div className="flex items-center gap-4">
        <div className="w-12 h-12 bg-neutral-50 rounded flex items-center justify-center">
          <RiBankCard2Line
            size={24}
            className="text-neutral-500"
          />
        </div>
        <div className="flex flex-col">
          <p className="text-base font-medium text-gray-900">
            { getPaymentSourceTitle(paymentSource) }
          </p>
          { (paymentSource.type === "card") && (
            <p className="text-sm text-gray-600">
              Expires {paymentSource.expiry.month}/{paymentSource.expiry.year}
            </p>
          ) }
        </div>
      </div>
      <Button
        text="CHANGE"
        onClick={onChangeClick}
        className="button button-secondary"
        size="SM"
      />
    </div>
  );
}
